var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "product-details",
    transform: "translate(-135.000000, -632.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-button-(1)",
    transform: "translate(135.000000, 632.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.026,0.002 C23.324,0.002 30.052,6.728 30.051,15.028 C30.051,23.324 23.324,30.049 15.026,30.049 C6.726,30.049 -5.22248911e-13,23.325 -5.22248911e-13,15.028 C-5.22248911e-13,6.728 6.726,0.002 15.026,0.002 Z M15.026,2.51 C8.114,2.51 2.51,8.118 2.51,15.028 C2.51,21.941 8.114,27.542 15.026,27.542 C21.937,27.542 27.541,21.941 27.54,15.028 C27.54,8.117 21.937,2.51 15.026,2.51 Z M12.958,9.84 C13.209,9.711 13.513,9.736 13.742,9.902 L13.742,9.902 L19.982,14.438 C20.177,14.58 20.295,14.803 20.2940063,15.045 C20.2940063,15.283 20.179,15.507 19.982,15.652 L19.982,15.652 L13.742,20.184 C13.61,20.281 13.454,20.33 13.3,20.33 C13.182,20.33 13.065,20.303 12.958,20.249 C12.705,20.121 12.547,19.862 12.547,19.578 L12.547,19.578 L12.547,10.509 C12.547,10.228 12.705,9.968 12.958,9.84 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideo);
export default __webpack_public_path__ + "static/media/ic_video.440220ce.svg";
export { ForwardRef as ReactComponent };